import { PrefermentFormFormula } from '@app/preferment-calc';

export interface StoredFormula {
  name: string;
  id: string;
  formula: PrefermentFormFormula;
}

export const prefermentStoreKey = 'PrefermentStoreService.savedPreferments';
